/** @format */

import { createContext, useContext, useState, useEffect } from "react";
import { fetchSheetData } from "../utils";

const MapContext = createContext();

export function MapProvider({ children }) {
  const [markers, setMarkers] = useState([]);
  const [mapInstance, setMapInstance] = useState(null);
  const [userCoords, setUserCoords] = useState(null);
  const [distance, setDistance] = useState(true);
  const [filteredMarkers, setFilteredMarkers] = useState([]);

  useEffect(() => {
    async function loadData() {
      const data = await fetchSheetData();
      setMarkers(data);
      setFilteredMarkers(data)
    }
    loadData();
  }, []);

  return (
    <MapContext.Provider
      value={{
        markers,
        setMarkers,
        mapInstance,
        setMapInstance,
        distance,
        setDistance,
        userCoords,
        setUserCoords,
        filteredMarkers,
        setFilteredMarkers,
      }}
    >
      {children}
    </MapContext.Provider>
  );
}

export const useMapContext = () => useContext(MapContext);
